import { render, staticRenderFns } from "./SportSubscriptionsEmails.vue?vue&type=template&id=72eaa036&scoped=true"
import script from "./SportSubscriptionsEmails.vue?vue&type=script&lang=js"
export * from "./SportSubscriptionsEmails.vue?vue&type=script&lang=js"
import style0 from "./SportSubscriptionsEmails.vue?vue&type=style&index=0&id=72eaa036&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72eaa036",
  null
  
)

export default component.exports